import { NativeResponseType } from "@swiggy-private/native-bridge";
import { STATUS_CODES } from "@swiggy-private/web-bridge-sdk";
import { isEmpty } from "@swiggy-private/js-utils";
import { isIxigoFlow } from "./Common";
import { getPreCartLinkFromStorage } from "./Storage";

interface NavigationResponse {
    statusCode: number;
    type: NativeResponseType;
    requestId: string;
}

const CART_FROM_LOGIN_FLOW_KEY = "cart_from_login_flow";

/**
 * Handles navigation to menu page when user is coming from login flow.
 * Returns navigation response if navigation succeeds, error response for Ixigo flow on failure,
 * or null for non-Ixigo flow to allow fallback to default behavior.
 */
export const handleLoginFlowNavigation = async (): Promise<NavigationResponse | null> => {
    const isSessionStorageAvailable = typeof window !== "undefined" && typeof sessionStorage !== "undefined";
    const cameFromLoginFlow = isSessionStorageAvailable && sessionStorage.getItem(CART_FROM_LOGIN_FLOW_KEY) === "true";

    if (!cameFromLoginFlow) {
        return null;
    }

    const isIxigo = isIxigoFlow();

    // Helper function: return error response for Ixigo flow, null for others (to fall through)
    const getErrorResponseIfNeeded = (): NavigationResponse | null => {
        return isIxigo ? { statusCode: STATUS_CODES.ERROR, type: NativeResponseType.FAILURE, requestId: "" } : null;
    };

    try {
        // sessionStorage is available here because cameFromLoginFlow is true
        sessionStorage.removeItem(CART_FROM_LOGIN_FLOW_KEY);

        const preCartLink = getPreCartLinkFromStorage();

        try {
            if (!isEmpty(preCartLink)) {
                window.location.replace(preCartLink);
                return { statusCode: 0, type: NativeResponseType.SUCCESS, requestId: "" };
            }

            // Navigation failed
            return getErrorResponseIfNeeded();
        } catch {
            // Navigation error
            return getErrorResponseIfNeeded();
        }
    } catch {
        // Outer catch
        return getErrorResponseIfNeeded();
    }
};
